import {
  MemberOrderPayload,
  MemberOrderRebateResponseType,
  MemberOrderResponseType,
  MemberOrderRewardResponseType,
  MemberPromotionPayload,
  MemberPromotionResponse,
} from "./type";

export const ordersApi = {
  async memberOrder(_username: string, payload: MemberOrderPayload) {
    return {
      status: 0,
      msg: "Success",
      data: [],
      totalCount: 0,
      totalPages: 1,
      currentPage: payload?.page || 1,
      pageSize: payload?.size || 10,
    } as MemberOrderResponseType;
  },

  async memberOrderRebate(_username: string, payload: MemberOrderPayload) {
    return {
      status: 0,
      msg: "Success",
      data: [],
      totalCount: 0,
      totalPages: 1,
      currentPage: payload?.page || 1,
      pageSize: payload?.size || 10,
    } as MemberOrderRebateResponseType;
  },
  async memberOrderReward(_username: string, payload: MemberOrderPayload) {
    return {
      status: 0,
      msg: "Success",
      data: [],
      totalCount: 0,
      totalPages: 1,
      currentPage: payload?.page || 1,
      pageSize: payload?.size || 10,
    } as MemberOrderRewardResponseType;
  },

  async memberPromotion(_username: string, payload: MemberPromotionPayload) {
    return {
      status: 0,
      msg: "Success",
      data: [],
      totalCount: 0,
      totalPages: 1,
      currentPage: payload?.page || 1,
      pageSize: payload?.size || 10,
    } as MemberPromotionResponse;
  },
};
